import type { App } from '@grafikr/components';
import header from 'layout/header';

import hasUrlParam from 'utils/loaders/has-url-param';
import intersectionLoader from 'utils/loaders/intersection';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import onEvent from 'utils/loaders/on-event';

export default (app: App) => {
  app.add({
    // Layout
    header,

    // Components
    accordion: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-accordion" */ 'components/accordion'),
    ],
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    'add-multiple-products-to-cart': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-add-multiple-products-to-cart" */ 'components/add-multiple-products-to-cart'
        ),
    ],
    'announcement-bar': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-announcement-bar" */ 'components/announcement-bar'),
    ],
    'cart-count': [
      onEvent,
      () => import(/* webpackChunkName: "component-cart-count" */ 'components/cart-count'),
    ],
    'cart-drawer': [
      [onEvent, onElementInteraction, hasUrlParam],
      () => import(/* webpackChunkName: "component-cart-drawer" */ 'components/cart-drawer'),
    ],
    'cart-notification': [
      onEvent,
      () =>
        import(
          /* webpackChunkName: "component-cart-notification" */ 'components/cart-notification'
        ),
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    drawer: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-drawer" */ 'components/drawer'),
    ],
    'header-drawer': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-header-drawer" */ 'components/header-drawer'),
    ],
    hero: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-hero" */ 'components/hero'),
    ],
    instafeed: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-instafeed" */ 'components/instafeed'),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],
    'list-layout': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-list-layout" */ 'components/list-layout'),
    ],
    'list-sort': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-list-sort" */ 'components/list-sort'),
    ],
    marquee: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-marquee" */ 'components/marquee'),
    ],
    pagination: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-pagination" */ 'components/pagination'),
    ],
    'predictive-search': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-predictive-search" */ 'components/predictive-search'
        ),
    ],
    quantity: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-quantity" */ 'components/quantity'),
    ],
    'quick-add-to-cart': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-quick-add-to-cart" */ 'components/quick-add-to-cart'
        ),
    ],
    'search-drawer': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-search-drawer" */ 'components/search-drawer'),
    ],
    splide: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-splide" */ 'components/splide'),
    ],
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],
    text: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-text" */ 'components/text'),
    ],
    'click-and-collect-drawer': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-click-and-collect-drawer" */ 'components/click-and-collect-drawer'
          ),
    ],
    'delivery-drawer': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-delivery-drawer" */ 'components/delivery-drawer'
          ),
    ],
    'product-delivery-availability': [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-product-delivery-availability" */ 'components/product-delivery-availability'
        ),
    ],

    // Pages
    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-form" */ 'pages/product/form'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
  });
};
